import type { AxiosResponse } from 'axios'
import jsFileDownload from 'js-file-download'

import { FILENAME_PREFIX_REGEX } from '@constants'

export function transformObjectToArray<
  InputObject extends Record<string, StringOrMessage>,
  KeyIsNumeric extends boolean,
>(obj: InputObject, keyIsNumeric?: KeyIsNumeric) {
  const entries = Object.entries(obj)

  return entries.map(([key, label]) => ({
    value: keyIsNumeric ? Number(key) : key,
    label,
  }))
}

// Download file via API response
function getFileName(response: AxiosResponse) {
  const defaultFileName = 'unknown'
  const contentDisposition = response.headers['content-disposition']
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(FILENAME_PREFIX_REGEX)
    return fileNameMatch?.[1] ?? defaultFileName
  } else {
    return defaultFileName
  }
}

export function downloadFileFromAPIHeaders(response: AxiosResponse) {
  const fileName = getFileName(response)
  jsFileDownload(response.data, fileName)
}

export function downloadFileWithURL<Response extends { path: BackendCallableLink }>(response: AxiosResponse<Response>) {
  const url = response.data.path

  if (url) {
    window.location.assign(url) // WARNING: Resource interpreted as Document but transferred with MIME type application/zip
  }
}
